import { useContext, useEffect, useRef, useState, useMemo } from 'react';
import "./index.css"
import { convertTicketFormat, formatEventDateRange, getDayFromDate, moneyRoundOff } from '../../../../utils/func';
import { DEFAULT_CURRENCY } from '../../../../constants';
import QuantityControls from '../../../quantityControls';
import NotifyDeleteButton from '../../../notifyDeleteButton';
import { REMOVE_RESERVATION_API } from '../../../../APIs';
import StockQuantity from '../../../../pages/TicketPage/Components/StockQuantity';
import { filterDataContext } from '../../../../App';
import { useLocation } from 'react-router-dom';
import { CHECKOUTPAGE } from '../../../../constants/RoutingPath';

const TicketDetail = ({ item, fetchCartList, index }) => {
    // const [cartQuantity, setCartQuantity] = useState(item?.quantity);
    const { reservationData, setReserVationData, reserveTicket } = useContext(filterDataContext)
    const location = useLocation()
    const handleGetDaysWithFormat = (day, validFrom) => {
        return day === "singleday"
            ? getDayFromDate(validFrom)
            : convertTicketFormat(day);
    }


    const handleDeleteReservationTicket = async (id) => {
        try {
            const payload = {
                ticket_id: id
            }
            const response = await REMOVE_RESERVATION_API(payload)
            if (response && response?.status) {
                fetchCartList()
            }
        } catch (error) {
            console.log(error, "RESERVATION_DELETE_API")
        }
    }

    const memoizedCartQuantity = useMemo(() => item?.quantity, [item?.quantity]);

    return (
        <div className="ticket_details" >
            <div className="item-details">
                <p>{`${item?.event_event?.tournament?.official_name} ${item?.event_event?.season}`} -
                    {formatEventDateRange(item?.event_event?.tournament?.date_start, item?.event_event?.tournament?.date_stop)}</p>
                <p> {`${item?.category_name}`} -
                    {handleGetDaysWithFormat(item?.eventdays, item?.ticket_validfrom)}
                </p>
                <p>{item?.event_event?.venue?.official_name}</p>
            </div>
            <div className="item-details">
                {/* <p>{cartQuantity} × {`${DEFAULT_CURRENCY} ${moneyRoundOff(
                    item.net_rate_inr
                )}`}</p> */}
                <StockQuantity item={item} key={index}
                    index={index}
                    // ticketName={ticketName}
                    reservationData={reservationData} setReserVationData={setReserVationData}
                    alreadySelectQuantity={memoizedCartQuantity}
                    reserveTicket={reserveTicket}
                />
                {/* <QuantityControls cartQuantity={cartQuantity} handleDecrease={handleDecrease} handleIncrease={handleIncrease} /> */}
            </div>
            {
                location.pathname !== CHECKOUTPAGE &&
                <div className='ticket_delete' >
                    <NotifyDeleteButton onClick={() => handleDeleteReservationTicket(item?.ticket_id)} />
                </div>
            }
        </div>
    )
}

export default TicketDetail